import { render, staticRenderFns } from "./LocationManagementPage.vue?vue&type=template&id=b4a9fc3a&scoped=true"
import script from "./LocationManagementPage.vue?vue&type=script&lang=js"
export * from "./LocationManagementPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b4a9fc3a",
  null
  
)

export default component.exports